export default __webpack_public_path__ + "static/media/Labirynth-05.7603f51e.svg";